import React from 'react';
import { SubscriptionTier, TIER_DISPLAY_NAMES, TIER_BADGE_COLORS } from '../types';
import './SubscriptionManagement.css';

interface SubscriptionManagementProps {
  currentTier: SubscriptionTier;
}

const TIER_FEATURES: Record<SubscriptionTier, string[]> = {
  free: [
    'Unlimited questions',
    'Basic knowledge base',
    '1 team member',
    'Community support'
  ],
  basic: [
    'Everything in Free',
    'Priority support',
    'Up to 5 team members',
    'Advanced analytics'
  ],
  pro: [
    'Everything in Basic',
    'Unlimited team members',
    'Custom integrations',
    'API access',
    'Priority email support'
  ],
  enterprise: [
    'Everything in Pro',
    'Dedicated account manager',
    'SLA guarantees',
    'Custom contracts',
    'On-premise deployment options'
  ]
};

const SubscriptionManagement: React.FC<SubscriptionManagementProps> = ({ currentTier }) => {
  const tierDisplayName = TIER_DISPLAY_NAMES[currentTier] || 'Free';
  const tierBadgeColor = TIER_BADGE_COLORS[currentTier] || TIER_BADGE_COLORS.free;
  const features = TIER_FEATURES[currentTier] || TIER_FEATURES.free;

  return (
    <div className="subscription-management">
      <div className="subscription-header">
        <h2>Subscription Management</h2>
        <p className="subtitle">Manage your subscription plan and billing</p>
      </div>

      <div className="current-plan-card">
        <div className="plan-header">
          <h3>Current Plan</h3>
          <span 
            className="tier-badge-large" 
            style={{ backgroundColor: tierBadgeColor }}
          >
            {tierDisplayName}
          </span>
        </div>
        
        <div className="plan-features">
          <h4>Features included:</h4>
          <ul>
            {features.map((feature, index) => (
              <li key={index}>
                <span className="check-icon">✓</span>
                {feature}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="upgrade-section">
        <div className="upgrade-card">
          <h3>Need more features?</h3>
          <p>
            Contact our sales team to learn about upgrading your subscription 
            or explore our other plans.
          </p>
          <a 
            href="mailto:sales@complydeck.com" 
            className="contact-sales-btn"
          >
            Contact Sales
          </a>
        </div>
      </div>

      <div className="billing-info">
        <h3>Billing Information</h3>
        <p className="coming-soon-text">
          Self-service billing management is coming soon. 
          For billing inquiries, please contact support.
        </p>
      </div>
    </div>
  );
};

export default SubscriptionManagement;

